(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["collection-filters"] && !Shopify.designMode) return;
  try {
    /*
   * Wraps the whole collection section (bar, active filters, results and the
   * filters drawer). Every region marked `data-facets-region` is swapped for
   * the server's once filters are applied.
   *
   * - Opening the panel (any [data-filters-open] trigger) starts from the
   *   applied filters: selections left unapplied when it was closed are
   *   dropped. A trigger with a filter's param name opens that filter alone,
   *   scrolled to the top of the panel.
   * - Every change refreshes the value counts and the "View X products"
   *   button live (sections/main-collection-facets.liquid), nothing is applied
   *   until the form is submitted.
   * - Filters and sort live in the URL (history entry per change, back/forward
   *   re-renders the matching results).
   */
  class CollectionFilters extends HTMLElement {
    connectedCallback() {
      this.sectionId = this.dataset.sectionId;
      this.liveSectionId = this.dataset.liveSectionId;
      this.renderedKey = this.urlKey(window.location.href);
      this.save();

      this.addEventListener('click', this.onClick.bind(this));
      this.addEventListener('change', this.onChange.bind(this));
      this.addEventListener('input', this.onInput.bind(this));
      this.addEventListener('submit', this.onSubmit.bind(this));

      this.onPopState = this.onPopState.bind(this);
      window.addEventListener('popstate', this.onPopState);
    }

    disconnectedCallback() {
      window.removeEventListener('popstate', this.onPopState);
    }

    get form() {
      return this.querySelector('[data-filters-form]');
    }

    get applyButton() {
      return this.querySelector('[data-filters-apply]');
    }

    get drawer() {
      return this.querySelector('x-drawer');
    }

    // The applied state, as rendered by the server
    save() {
      this.savedForm = this.form?.innerHTML;
      this.savedApply = this.applyButton?.innerHTML;
    }

    restore() {
      this.controller?.abort();
      if (this.form && this.savedForm !== undefined) this.form.innerHTML = this.savedForm;
      if (this.applyButton && this.savedApply !== undefined) {
        this.applyButton.innerHTML = this.savedApply;
        this.applyButton.disabled = false;
      }
    }

    onClick(event) {
      const opener = event.target.closest('[data-filters-open]');
      if (opener) {
        this.restore();
        this.openFilter(opener.dataset.filtersOpen);
        return;
      }

      const removeLink = event.target.closest('a[data-remove-filter]');
      if (removeLink) {
        event.preventDefault();
        this.apply(removeLink.href);
        return;
      }

      const more = event.target.closest('[data-filter-more]');
      if (more) {
        const list = more.closest('[data-filter-values]');
        list.setAttribute('data-expanded', '');
        this.layoutList(list);
        return;
      }

      if (event.target.closest('[data-filters-reset]')) this.resetSelections();
    }

    // Only the requested filter is open, at the top of the panel (the drawer
    // is shown right after, by its own trigger listener).
    openFilter(param) {
      const form = this.form;
      if (!form) return;

      const scroller = this.drawer?.shadowRoot?.querySelector('.x-drawer__content');
      if (!param) {
        if (scroller) scroller.scrollTop = 0;
        return;
      }

      form.setAttribute('data-instant', '');
      let target;
      form.querySelectorAll('details[data-filter]').forEach((details) => {
        details.open = details.dataset.filter === param;
        if (details.open) target = details;
      });

      requestAnimationFrame(() => {
        requestAnimationFrame(() => {
          if (target && scroller) {
            scroller.scrollTop += target.getBoundingClientRect().top - scroller.getBoundingClientRect().top;
          }
          form.removeAttribute('data-instant');
        });
      });
    }

    onChange(event) {
      if (!this.form?.contains(event.target)) return;
      if (event.target.name || event.target.matches('[data-price-slider]')) this.refresh();
    }

    onInput(event) {
      const target = event.target;

      if (target.matches('[data-filter-search]')) {
        this.layoutList(target.closest('[data-filter-values]'));
      } else if (target.matches('[data-price-slider], [data-price-field]')) {
        this.syncPrice(target.closest('[data-price-range]'), target);
      }
    }

    onSubmit(event) {
      if (event.target !== this.form) return;
      event.preventDefault();
      this.apply(this.buildUrl());
    }

    params() {
      const params = new URLSearchParams();
      for (const [key, value] of new FormData(this.form)) {
        if (value === '') continue;
        if (key === 'sort_by' && value === this.form.dataset.defaultSort) continue;
        params.append(key, value);
      }
      return params;
    }

    buildUrl(params = this.params()) {
      const query = params.toString();
      return `${this.form.action}${query ? `?${query}` : ''}`;
    }

    // Live counts: values left without products are hidden, the apply button
    // shows the number of products the current selection would give.
    refresh() {
      clearTimeout(this.refreshTimer);
      this.refreshTimer = setTimeout(() => this.fetchCounts(), 200);
    }

    async fetchCounts() {
      if (!this.form || !this.liveSectionId) return;

      this.controller?.abort();
      this.controller = new AbortController();

      const params = this.params();
      params.set('section_id', this.liveSectionId);
      this.applyButton?.setAttribute('data-loading', '');

      try {
        const response = await fetch(this.buildUrl(params), { signal: this.controller.signal });
        if (!response.ok) throw new Error(response.status);

        const doc = new DOMParser().parseFromString(await response.text(), 'text/html');
        this.syncCounts(doc);
        this.applyButton?.removeAttribute('data-loading');
      } catch (error) {
        if (error.name !== 'AbortError') this.applyButton?.removeAttribute('data-loading');
      }
    }

    syncCounts(doc) {
      const key = (input) => `${input.name}\n${input.value}`;
      const counts = new Map();
      doc.querySelectorAll('[data-filter-value]').forEach((item) => {
        const input = item.querySelector('input');
        if (input) counts.set(key(input), Number(item.dataset.count) || 0);
      });

      this.form.querySelectorAll('[data-filter-value]').forEach((item) => {
        const input = item.querySelector('input');
        if (!input) return;

        const count = counts.get(key(input)) ?? 0;
        item.dataset.count = count;
        const countLabel = item.querySelector('[data-value-count]');
        if (countLabel) countLabel.textContent = `(${count})`;
        item.hidden = count === 0 && !input.checked;
      });

      this.form.querySelectorAll('[data-filter-values][data-long]').forEach((list) => this.layoutList(list));

      const label = doc.querySelector('[data-filters-apply-label]');
      if (label && this.applyButton) {
        this.applyButton.innerHTML = label.innerHTML;
        this.applyButton.disabled = label.dataset.count === '0';
      }
    }

    // Long lists: first values only until "Show more", or the values matching the search
    layoutList(list) {
      if (!list?.dataset.long) return;

      const limit = Number(list.dataset.long);
      const normalize = (text) =>
        text
          .normalize('NFD')
          .replace(/[̀-ͯ]/g, '')
          .toLowerCase()
          .trim();
      const query = normalize(list.querySelector('[data-filter-search]')?.value ?? '');
      const expanded = list.hasAttribute('data-expanded');

      let shown = 0;
      list.querySelectorAll('[data-filter-value]').forEach((item) => {
        const match = !query || normalize(item.dataset.label).includes(query);
        item.toggleAttribute('data-search-miss', !match);
        if (item.hidden || !match) {
          item.removeAttribute('data-more');
          return;
        }

        shown += 1;
        item.toggleAttribute('data-more', !query && !expanded && shown > limit);
      });

      const more = list.querySelector('[data-filter-more]');
      if (more) more.hidden = Boolean(query) || expanded || shown <= limit;
    }

    // Keeps the Min / Max fields and the slider in step. Fields at the range's
    // bounds stay empty, so they're left out of the URL.
    syncPrice(range, source) {
      if (!range) return;

      const [minSlider, maxSlider] = range.querySelectorAll('[data-price-slider]');
      const [minField, maxField] = range.querySelectorAll('[data-price-field]');
      const bound = Number(range.dataset.max);

      if (source.matches('[data-price-slider]')) {
        let min = Number(minSlider.value);
        let max = Number(maxSlider.value);
        if (min > max) {
          if (source === minSlider) min = max;
          else max = min;
          minSlider.value = min;
          maxSlider.value = max;
        }
        minField.value = min > 0 ? min : '';
        maxField.value = max < bound ? max : '';
      } else {
        minSlider.value = minField.value || 0;
        maxSlider.value = maxField.value || bound;
      }

      const slider = minSlider.parentElement;
      slider.style.setProperty('--range-min', minSlider.value);
      slider.style.setProperty('--range-max', maxSlider.value);
    }

    // "Reset": clears the selection in the panel, applied like any other change
    resetSelections() {
      const form = this.form;
      if (!form) return;

      form.querySelectorAll('input[type="checkbox"]').forEach((input) => (input.checked = false));
      form.querySelectorAll('input[name="sort_by"]').forEach((input) => {
        input.checked = input.value === form.dataset.defaultSort;
      });
      form.querySelectorAll('[data-price-range]').forEach((range) => {
        range.querySelectorAll('[data-price-field]').forEach((field) => (field.value = ''));
        this.syncPrice(range, range.querySelector('[data-price-field]'));
      });

      this.refresh();
    }

    async apply(url, { push = true } = {}) {
      this.controller?.abort();
      this.drawer?.close();

      const requestUrl = new URL(url, window.location.origin);
      requestUrl.searchParams.set('sections', this.sectionId);

      const results = this.querySelector('[data-facets-region="results"]');
      results?.setAttribute('data-loading', '');

      try {
        const response = await fetch(requestUrl);
        if (!response.ok) throw new Error(response.status);

        const sections = await response.json();
        const doc = new DOMParser().parseFromString(sections[this.sectionId], 'text/html');

        // Before the swap: the new results store their page in this new entry
        requestUrl.searchParams.delete('sections');
        const path = requestUrl.pathname + requestUrl.search;
        if (push) window.history.pushState({}, '', path);
        this.renderedKey = this.urlKey(path);

        this.querySelectorAll('[data-facets-region]').forEach((region) => {
          const updated = doc.querySelector(`[data-facets-region="${region.dataset.facetsRegion}"]`);
          if (updated) region.replaceWith(updated);
        });

        this.save();

        const main = this.querySelector('.collection__main');
        if (main && main.getBoundingClientRect().top < 0) main.scrollIntoView({ behavior: 'smooth' });
      } catch {
        window.location.href = url;
      }
    }

    // Filters and sort of a URL, whatever the page
    urlKey(url) {
      const { pathname, searchParams } = new URL(url, window.location.origin);
      ['page', 'sections', 'section_id'].forEach((param) => searchParams.delete(param));
      searchParams.sort();
      return `${pathname}?${searchParams}`;
    }

    onPopState() {
      if (this.urlKey(window.location.href) === this.renderedKey) return;
      this.apply(window.location.href, { push: false });
    }
  }

  customElements.define('collection-filters', CollectionFilters);
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["facets"] && !Shopify.designMode) return;
  try {
    class FacetsForm extends HTMLElement {
    connectedCallback() {
      this.form = this.querySelector('form');
      this.sectionId = this.dataset.sectionId;

      this.form.addEventListener('submit', this.onSubmit.bind(this));
      this.addEventListener('click', this.onRemoveClick.bind(this));

      if (this.hasAttribute('data-auto-submit')) {
        this.form.addEventListener('change', this.onChange.bind(this));
      }
    }

    onChange(event) {
      if (!event.target.matches('input')) return;
      this.form.requestSubmit();
    }

    onRemoveClick(event) {
      const pill = event.target.closest('[data-remove-filter]');
      if (!pill) return;

      event.preventDefault();
      this.applyUrl(pill.href);
    }

    onSubmit(event) {
      event.preventDefault();

      const params = new URLSearchParams(new FormData(this.form));
      this.applyUrl(`${this.form.action}?${params}`);
      this.closest('x-drawer')?.close();
    }

    async applyUrl(url) {
      const requestUrl = new URL(url, window.location.origin);
      requestUrl.searchParams.set('sections', this.sectionId);

      this.form.setAttribute('data-loading', '');

      const response = await fetch(requestUrl);
      if (!response.ok) {
        this.form.removeAttribute('data-loading');
        return;
      }

      const sections = await response.json();
      const doc = new DOMParser().parseFromString(sections[this.sectionId], 'text/html');

      document.querySelectorAll('[data-facets-region]').forEach((region) => {
        const updated = doc.querySelector(`[data-facets-region="${region.dataset.facetsRegion}"]`);
        if (updated) region.replaceWith(updated);
      });

      requestUrl.searchParams.delete('sections');
      window.history.replaceState({}, '', requestUrl.pathname + requestUrl.search);
    }
  }

  customElements.define('facets-form', FacetsForm);
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["global-web-components"] && !Shopify.designMode) return;
  try {
    class QuantitySelector extends HTMLElement {
    connectedCallback() {
      this.input = this.querySelector('input');
      this.addEventListener('click', this.onButtonClick.bind(this));
      this.input.addEventListener('change', this.onInputChange.bind(this));
    }

    get min() {
      return Number(this.dataset.min ?? 1);
    }

    get max() {
      return Number(this.dataset.max ?? Infinity);
    }

    clamp(value) {
      return Math.min(Math.max(value, this.min), this.max);
    }

    onButtonClick(event) {
      const button = event.target.closest('button');
      if (!button) return;

      this.input.value = this.clamp(Number(this.input.value) + Number(button.dataset.step));
      this.input.dispatchEvent(new Event('change', { bubbles: true }));
    }

    onInputChange() {
      this.input.value = this.clamp(Number(this.input.value) || this.min);
    }
  }

  customElements.define('quantity-selector', QuantitySelector);

  class ScrollingContent extends HTMLElement {
    connectedCallback() {
      this.classList.add('scrolling-content');
      this.scroller = this.findScroller();

      this.scroller.addEventListener('scroll', this.update.bind(this), { passive: true });
      new ResizeObserver(() => this.update()).observe(this.scroller);
      this.querySelector('slot')?.addEventListener('slotchange', () => this.update());

      this.update();
    }

    // The scrollable box is usually the component itself, but some usages
    // (e.g. the tablist inside <x-tabs>) scroll a wrapping child instead.
    findScroller() {
      const vertical = this.dataset.direction === 'vertical';
      const overflows = (el) => (vertical ? el.scrollHeight > el.clientHeight : el.scrollWidth > el.clientWidth);

      if (overflows(this)) return this;
      return [...this.children].find(overflows) ?? this;
    }

    update() {
      const vertical = this.dataset.direction === 'vertical';
      const scrollPosition = vertical ? this.scroller.scrollTop : this.scroller.scrollLeft;
      const maxScroll = vertical
        ? this.scroller.scrollHeight - this.scroller.clientHeight
        : this.scroller.scrollWidth - this.scroller.clientWidth;

      this.toggleAttribute('data-overflow-start', scrollPosition > 1);
      this.toggleAttribute('data-overflow-end', scrollPosition < maxScroll - 1);
    }
  }

  customElements.define('scrolling-content', ScrollingContent);

  class XDrawer extends HTMLElement {
    // IDs of drawers the theme editor currently has selected, so they reopen
    // after the re-render that follows every setting change.
    static editorOpen = new Set();

    connectedCallback() {
      if (this.shadowRoot) return this.setupThemeEditor();

      const template = document.getElementById('x-drawer-template');
      this.attachShadow({ mode: 'open' }).append(template.content.cloneNode(true));

      this.dialog = this.shadowRoot.querySelector('dialog');
      this.dialog.addEventListener('close', () => {
        document.documentElement.classList.remove('scroll-lock');
        this.setTriggersExpanded(false);
      });

      this.dialog.addEventListener('click', (event) => {
        if (event.target === this.dialog) this.close();
      });

      const headingSlot = this.shadowRoot.querySelector('slot[name="heading"]');
      const linkHeading = () => {
        const [heading] = headingSlot.assignedElements();
        if (!heading) return;
        heading.id ||= `${this.id}-heading`;
        this.dialog.setAttribute('aria-labelledby', heading.id);
      };
      headingSlot.addEventListener('slotchange', linkHeading);
      linkHeading();

      const footerSlot = this.shadowRoot.querySelector('slot[name="footer"]');
      const footer = footerSlot.closest('.x-drawer__footer');
      const toggleFooter = () => (footer.hidden = footerSlot.assignedNodes().length === 0);
      footerSlot.addEventListener('slotchange', toggleFooter);
      toggleFooter();

      const asideSlot = this.shadowRoot.querySelector('slot[name="aside"]');
      const aside = asideSlot.closest('.x-drawer__aside');
      const toggleAside = () => (aside.hidden = asideSlot.assignedNodes().length === 0);
      asideSlot.addEventListener('slotchange', toggleAside);
      toggleAside();

      this.setupThemeEditor();
    }

    disconnectedCallback() {
      this.editorController?.abort();
    }

    // Opt-in with data-editor-open="section" or "block": the drawer opens
    // while the theme editor has its own section or block selected (or, for
    // "block", one of the child blocks rendered inside it), so its settings
    // can be previewed without clicking the trigger.
    setupThemeEditor() {
      const scope = this.dataset.editorOpen;
      if (!window.Shopify?.designMode || !scope) return;

      this.editorController = new AbortController();
      const { signal } = this.editorController;
      const owner = scope === 'section' ? '.shopify-section' : '[data-shopify-editor-block]';
      const isOwn = (event) =>
        event.target === this.closest(owner) || (scope === 'block' && this.contains(event.target));

      document.addEventListener(
        `shopify:${scope}:select`,
        (event) => {
          if (!isOwn(event)) return;
          XDrawer.editorOpen.add(this.id);
          this.show();
        },
        { signal }
      );

      document.addEventListener(
        `shopify:${scope}:deselect`,
        (event) => {
          if (!isOwn(event)) return;
          XDrawer.editorOpen.delete(this.id);
          this.close();
        },
        { signal }
      );

      if (XDrawer.editorOpen.has(this.id)) this.show();
    }

    show() {
      // Guard against re-entrant calls (e.g. adding to cart from a
      // recommendation rendered inside the already-open cart drawer):
      // showModal() throws if the dialog is already open.
      if (!this.dialog.open) this.dialog.showModal();
      this.setTriggersExpanded(true);
      document.documentElement.classList.add('scroll-lock');
    }

    close() {
      this.dialog.close();
      document.documentElement.classList.remove('scroll-lock');
    }

    setTriggersExpanded(expanded) {
      document
        .querySelectorAll(`[aria-controls="${this.id}"]`)
        .forEach((trigger) => trigger.setAttribute('aria-expanded', String(expanded)));
    }
  }

  customElements.define('x-drawer', XDrawer);

  // Theme editor: selecting a collapsible block (see snippets/accordion.liquid,
  // where the block's editor attributes sit on the <details> itself) opens it.
  if (window.Shopify?.designMode) {
    document.addEventListener('shopify:block:select', (event) => {
      if (event.target instanceof HTMLDetailsElement) event.target.open = true;
    });
  }

  class XTabs extends HTMLElement {
    connectedCallback() {
      if (this.shadowRoot) return;

      const template = document.getElementById('x-tabs-template');
      this.attachShadow({ mode: 'open' }).append(template.content.cloneNode(true));

      this.tabs = Array.from(this.querySelectorAll(':scope > [slot="tab"]'));
      this.panels = Array.from(this.querySelectorAll(':scope > [slot="panel"]'));
      this.descriptions = Array.from(this.querySelectorAll(':scope > [slot="description"]'));

      this.tabs.forEach((tab, index) => {
        const panel = this.panels[index];
        if (!panel) return;

        tab.id ||= `${this.id}-tab-${index}`;
        panel.id ||= `${this.id}-panel-${index}`;

        tab.setAttribute('role', 'tab');
        tab.setAttribute('aria-controls', panel.id);

        panel.setAttribute('role', 'tabpanel');
        panel.setAttribute('tabindex', '0');
        panel.setAttribute('aria-labelledby', tab.id);

        const description = this.descriptions[index];
        if (description?.textContent.trim()) {
          description.id ||= `${this.id}-description-${index}`;
          tab.setAttribute('aria-describedby', description.id);
        }
      });

      this.addEventListener('click', this.onTabClick.bind(this));
      this.addEventListener('keydown', this.onKeydown.bind(this));

      // Lets the theme editor jump to the right panel when a hidden tab's block is selected.
      this.addEventListener('shopify:block:select', this.onBlockSelect.bind(this));

      this.select(0);
    }

    onTabClick(event) {
      const tab = event.target.closest('[slot="tab"]');
      if (!tab) return;

      const index = this.tabs.indexOf(tab);
      if (index !== -1) this.select(index);
      tab.scrollIntoView({ behavior: 'smooth', inline: 'center', block: 'nearest' });
    }

    onKeydown(event) {
      const tab = event.target.closest('[slot="tab"]');
      if (!tab) return;

      const currentIndex = this.tabs.indexOf(tab);
      const lastIndex = this.tabs.length - 1;

      const indexByKey = {
        ArrowRight: (currentIndex + 1) % this.tabs.length,
        ArrowDown: (currentIndex + 1) % this.tabs.length,
        ArrowLeft: (currentIndex - 1 + this.tabs.length) % this.tabs.length,
        ArrowUp: (currentIndex - 1 + this.tabs.length) % this.tabs.length,
        Home: 0,
        End: lastIndex,
      };

      const newIndex = indexByKey[event.key];
      if (newIndex === undefined) return;

      event.preventDefault();
      this.select(newIndex);
      this.tabs[newIndex].focus();
      this.tabs[newIndex].scrollIntoView({ behavior: 'smooth', inline: 'center', block: 'nearest' });
    }

    onBlockSelect(event) {
      const panel = event.target.closest('[slot="panel"]');
      if (!panel) return;

      const index = this.panels.indexOf(panel);
      if (index !== -1) this.select(index);
    }

    select(index) {
      this.tabs.forEach((tab, i) => {
        const selected = i === index;
        tab.setAttribute('aria-selected', String(selected));
        tab.tabIndex = selected ? 0 : -1;
        this.panels[i].hidden = !selected;
        if (this.descriptions[i]) this.descriptions[i].hidden = !selected;
      });
    }
  }

  customElements.define('x-tabs', XTabs);

  document.addEventListener('click', (event) => {
    const trigger = event.target.closest('[aria-controls]');
    if (!trigger) return;

    const drawer = document.getElementById(trigger.getAttribute('aria-controls'));
    if (!(drawer instanceof XDrawer)) return;

    const template = trigger.nextElementSibling;
    if (trigger.hasAttribute('data-quick-view-trigger') && template instanceof HTMLTemplateElement) {
      drawer.replaceChildren(template.content.cloneNode(true));
    }

    drawer.show();
  });

  // Links that open a panel (data-panel = drawer id) once it exists, and
  // just follow their href until then (e.g. "Contactez-nous", "Le Club").
  document.addEventListener('click', (event) => {
    const link = event.target.closest('[data-panel]');
    const drawer = link && document.getElementById(link.dataset.panel);
    if (!(drawer instanceof XDrawer)) return;

    event.preventDefault();
    drawer.show();
  });

  window.updateCartCount = function (count) {
    const counter = document.querySelector('.header__cart-count');
    if (counter) counter.textContent = `(${count})`;
  };

  /**
   * Shared cart-mutation behavior (quantity change, line removal, discount
   * code and note submission) for any element rendering cart items. The
   * consuming class only needs to implement `render(sections)`.
   */
  const CartFormMixin = (Base) =>
    class extends Base {
      connectedCallback() {
        super.connectedCallback?.();
        this.addEventListener('change', this.onQuantityChange.bind(this));
        this.addEventListener('click', this.onRemoveClick.bind(this));
        this.addEventListener('submit', this.onDiscountSubmit.bind(this));
        this.addEventListener('submit', this.onNoteSubmit.bind(this));
      }

      get cartSections() {
        return [this.dataset.sectionId];
      }

      onQuantityChange(event) {
        const quantitySelector = event.target.closest('quantity-selector');
        if (!quantitySelector) return;

        this.changeLine(quantitySelector.closest('.cart-item'), Number(event.target.value));
      }

      onRemoveClick(event) {
        if (!event.target.closest('cart-item-remove')) return;

        this.changeLine(event.target.closest('.cart-item'), 0);
      }

      async changeLine(item, quantity) {
        if (!item) return;

        item.setAttribute('data-loading', '');

        const response = await fetch(window.routes.cart_change, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ id: item.dataset.key, quantity, sections: this.cartSections }),
        });

        if (!response.ok) {
          item.removeAttribute('data-loading');
          return;
        }

        const { sections, item_count } = await response.json();
        window.updateCartCount(item_count);
        this.render(sections);
      }

      async onDiscountSubmit(event) {
        const form = event.target.closest('[data-cart-discount-form]');
        if (!form) return;

        event.preventDefault();

        const input = form.querySelector('input[name="discount"]');
        const code = input.value.trim();
        if (!code) return;

        form.setAttribute('data-loading', '');

        const response = await fetch(window.routes.cart_update, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ discount: code, sections: this.cartSections }),
        });

        form.removeAttribute('data-loading');

        if (!response.ok) return;

        const { sections, item_count } = await response.json();
        window.updateCartCount(item_count);
        this.render(sections);
      }

      async onNoteSubmit(event) {
        const form = event.target.closest('[data-cart-note-form]');
        if (!form) return;

        event.preventDefault();

        const note = form.querySelector('textarea[name="note"]').value;

        form.setAttribute('data-loading', '');

        await fetch(window.routes.cart_update, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ note }),
        });

        form.removeAttribute('data-loading');
      }
    };

  class AddToCart extends HTMLElement {
    connectedCallback() {
      this.addEventListener('submit', this.onSubmit.bind(this));
    }

    get button() {
      return this.querySelector('[type="submit"]');
    }

    get cartDrawer() {
      return document.getElementById('cart-drawer');
    }

    async onSubmit(event) {
      event.preventDefault();

      if (this.button) {
        this.button.setAttribute('aria-busy', true);
      }

      const formData = new FormData(event.target);
      if (this.cartDrawer) formData.append('sections', this.cartDrawer.dataset.sectionId);

      const response = await fetch(this.dataset.cartAddUrl, {
        method: 'POST',
        headers: { Accept: 'application/json' },
        body: formData,
      });

      if (!response.ok) {
        this.button?.removeAttribute('aria-busy');
        return;
      }

      const { sections } = await response.json();
      const cart = await (await fetch(`${window.routes.cart}.js`)).json();
      window.updateCartCount(cart.item_count);

      this.closest('x-drawer')?.close();

      if (this.cartDrawer) {
        this.cartDrawer.render(sections);
        this.cartDrawer.show();
      } else {
        window.location.href = window.routes.cart;
      }

      if (this.button) {
        this.button.removeAttribute('aria-busy');
      }
    }
  }

  customElements.define('add-to-cart', AddToCart);

  // Builds a one-click, multi-product bundle (see sections/bundle-builder.liquid
  // and snippets/bundle-item.liquid): tracks the checked/excluded rows and their
  // quantities, live-recalculates the total and compare-at savings, then adds
  // every included row to the cart in a single request.
  class BundleBuilder extends HTMLElement {
    connectedCallback() {
      this.addEventListener('change', this.onChange.bind(this));
      this.addEventListener('click', this.onSubmitClick.bind(this));
      this.recalculate();
    }

    get rows() {
      return [...this.querySelectorAll('[data-bundle-item]')];
    }

    formatMoney(cents) {
      if (!this.moneyFormatter) {
        this.moneyFormatter = new Intl.NumberFormat(this.dataset.locale, {
          style: 'currency',
          currency: this.dataset.currency,
        });
      }

      return this.moneyFormatter.format(cents / 100);
    }

    // Mirrors the "% off" vs "amount off" badge picked in snippets/price.liquid,
    // so a variant switch (see onVariantChange) keeps showing the same kind of badge.
    formatBadge(price, compareAtPrice) {
      const savings = compareAtPrice - price;
      const percentage = Math.floor((savings * 100) / compareAtPrice);
      return percentage > savings / 100 ? `-${percentage}%` : `-${this.formatMoney(savings)}`;
    }

    onChange(event) {
      if (event.target.closest('[data-bundle-item-variant-select]')) {
        this.onVariantChange(event);
      }

      this.recalculate();
    }

    // Swaps a row's variant-dependent data (price, image, availability, stock)
    // using the JSON payload snippets/bundle-item.liquid embeds for products
    // with more than one variant, without a page reload.
    //
    // This does NOT use the Section Rendering API's `?variant=` trick (as
    // ProductForm.refreshVariantRegions does on the main product page):
    // that parameter only overrides `selected_or_first_available_variant`
    // for the page's own canonical product, and has no effect on a product
    // reached through a collection/product_list loop like these rows are
    // (confirmed empirically — the refreshed markup kept the default variant).
    onVariantChange(event) {
      const select = event.target.closest('[data-bundle-item-variant-select]');
      const row = select.closest('[data-bundle-item]');
      const payload = row.querySelector('[data-bundle-item-variants]');
      if (!payload) return;

      const variant = JSON.parse(payload.textContent).find((v) => v.id === Number(select.value));
      if (!variant) return;

      row.dataset.variantId = variant.id;
      row.dataset.price = variant.price;
      row.dataset.compareAtPrice = variant.compareAtPrice;
      row.dataset.available = variant.available;
      row.classList.toggle('bundle-item--sold-out', !variant.available);

      const image = row.querySelector('.bundle-item__media img');
      if (image && variant.image) {
        image.removeAttribute('srcset');
        image.removeAttribute('sizes');
        image.src = variant.image;
      }

      const onSale = variant.compareAtPrice > variant.price;

      const priceEl = row.querySelector('[data-bundle-item-price]');
      if (priceEl) priceEl.textContent = this.formatMoney(variant.price);

      const compareEl = row.querySelector('[data-bundle-item-compare]');
      if (compareEl) {
        compareEl.hidden = !onSale;
        compareEl.textContent = this.formatMoney(variant.compareAtPrice);
      }

      const badgeEl = row.querySelector('[data-bundle-item-badge]');
      if (badgeEl) {
        badgeEl.hidden = !onSale;
        if (onSale) badgeEl.textContent = this.formatBadge(variant.price, variant.compareAtPrice);
      }

      const soldOutEl = row.querySelector('[data-bundle-item-sold-out]');
      if (soldOutEl) soldOutEl.hidden = variant.available;

      const checkbox = row.querySelector('.bundle-item__checkbox');
      if (checkbox) {
        checkbox.disabled = !variant.available;
        checkbox.checked = variant.available;
      }

      const quantitySelector = row.querySelector('quantity-selector');
      const quantityInput = row.querySelector('input[name="quantity"]');
      const hasMax = variant.inventoryTracked && variant.inventoryPolicy !== 'continue';
      const max = hasMax ? variant.inventoryQuantity : 999;

      if (quantitySelector) quantitySelector.dataset.max = max;

      if (quantityInput) {
        quantityInput.max = max;
        quantityInput.value = Math.min(Number(quantityInput.value) || 1, max);
      }
    }

    recalculate() {
      let total = 0;
      let compareTotal = 0;
      let count = 0;

      this.rows.forEach((row) => {
        const checkbox = row.querySelector('.bundle-item__checkbox');
        const quantity = Number(row.querySelector('input[name="quantity"]')?.value ?? 1);
        const price = Number(row.dataset.price);
        const compareAtPrice = Number(row.dataset.compareAtPrice) || price;
        const included = Boolean(checkbox?.checked) && row.dataset.available === 'true';

        row.classList.toggle('bundle-item--excluded', !included);

        if (!included) return;

        total += price * quantity;
        compareTotal += compareAtPrice * quantity;
        count += quantity;
      });

      const savings = compareTotal - total;

      const totalEl = this.querySelector('[data-bundle-total]');
      if (totalEl) totalEl.textContent = this.formatMoney(total);

      const compareEl = this.querySelector('[data-bundle-compare-total]');
      if (compareEl) {
        compareEl.hidden = savings <= 0;
        compareEl.textContent = this.formatMoney(compareTotal);
      }

      const countEl = this.querySelector('[data-bundle-count]');
      if (countEl) countEl.textContent = count > 0 ? this.dataset.countLabel.replace('[count]', count) : '';

      const savingsEl = this.querySelector('[data-bundle-savings]');
      if (savingsEl) {
        savingsEl.hidden = savings <= 0;
        savingsEl.textContent = this.dataset.savingsLabel.replace('[amount]', this.formatMoney(savings));
      }

      const submit = this.querySelector('[data-bundle-submit]');
      if (submit) submit.disabled = count === 0;
    }

    async onSubmitClick(event) {
      const button = event.target.closest('[data-bundle-submit]');
      if (!button) return;

      const items = this.rows
        .filter((row) => row.dataset.available === 'true' && row.querySelector('.bundle-item__checkbox')?.checked)
        .map((row) => ({
          id: Number(row.dataset.variantId),
          quantity: Number(row.querySelector('input[name="quantity"]')?.value ?? 1),
        }));

      if (items.length === 0) return;

      button.setAttribute('aria-busy', true);
      this.hideError();

      try {
        const cartDrawer = document.getElementById('cart-drawer');
        const response = await fetch(this.dataset.cartAddUrl, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items, sections: cartDrawer?.dataset.sectionId }),
        });

        const result = await response.json();

        if (!response.ok) {
          this.showError(result.description || result.message);
          return;
        }

        const cart = await (await fetch(`${window.routes.cart}.js`)).json();
        window.updateCartCount(cart.item_count);

        if (cartDrawer && result.sections) {
          cartDrawer.render(result.sections);
          cartDrawer.show();
        } else {
          window.location.href = window.routes.cart;
        }
      } catch (error) {
        this.showError(this.dataset.errorLabel);
      } finally {
        button.removeAttribute('aria-busy');
      }
    }

    showError(message) {
      const error = this.querySelector('[data-bundle-error]');
      if (!error) return;

      error.textContent = message || this.dataset.errorLabel;
      error.hidden = false;
    }

    hideError() {
      const error = this.querySelector('[data-bundle-error]');
      if (error) error.hidden = true;
    }
  }

  customElements.define('bundle-builder', BundleBuilder);

  class ProductForm extends AddToCart {
    connectedCallback() {
      super.connectedCallback();

      const data = this.querySelector('[data-product-variants]');
      this.variants = data ? JSON.parse(data.textContent) : [];

      this.addEventListener('change', this.onOptionChange.bind(this));
      this.updateAvailability();
    }

    get optionInputs() {
      return [...this.querySelectorAll('[data-option-position]')];
    }

    get selectedOptions() {
      const positions = [...new Set(this.optionInputs.map((el) => el.dataset.optionPosition))].sort((a, b) => a - b);

      return positions.map((position) => {
        const group = this.optionInputs.filter((el) => el.dataset.optionPosition === position);
        const active = group.find((el) => (el.matches('select') ? true : el.checked));
        return active?.value;
      });
    }

    get selectedVariant() {
      const options = this.selectedOptions;
      return this.variants.find((variant) => variant.options.every((value, index) => value === options[index]));
    }

    get selectedSellingPlan() {
      return this.querySelector('[data-selling-plan]:checked')?.value;
    }

    onOptionChange(event) {
      const optionInput = event.target.closest('[data-option-position]');
      const sellingPlanInput = event.target.closest('[data-selling-plan]');
      if (!optionInput && !sellingPlanInput) return;

      if (optionInput) {
        const valueLabel = optionInput.closest('.variant-picker__option')?.querySelector('.variant-picker__value');
        if (valueLabel) valueLabel.textContent = optionInput.value;

        this.updateAvailability();
      }

      this.applyVariant(this.selectedVariant);
    }

    // Marks option values that can't be reached from the rest of the current selection.
    updateAvailability() {
      const selected = this.selectedOptions;

      this.optionInputs.forEach((input) => {
        const position = Number(input.dataset.optionPosition) - 1;
        const candidate = selected.map((value, index) => (index === position ? input.value : value));

        const reachable = this.variants.some(
          (variant) => variant.available && variant.options.every((value, index) => value === candidate[index])
        );

        input.toggleAttribute('data-unavailable', !reachable);
      });
    }

    applyVariant(variant) {
      const idInput = this.querySelector('input[name="id"]');

      this.toggleAttribute('data-unavailable-combination', !variant);

      if (!variant) {
        if (idInput) idInput.value = '';
        if (this.button) this.button.disabled = true;
        return;
      }

      if (idInput) idInput.value = variant.id;
      if (this.button) this.button.disabled = !variant.available;

      // The checked radio can be stale: it reflects the plan picked for the
      // *previous* variant, read before its region has been swapped for this
      // one. Drop it if the new variant doesn't actually offer that plan,
      // instead of carrying a mismatched id into the URL and the request below.
      let sellingPlan = this.selectedSellingPlan;
      if (sellingPlan && !variant.selling_plan_ids?.includes(Number(sellingPlan))) sellingPlan = null;

      const url = new URL(window.location.href);
      url.searchParams.set('variant', variant.id);
      if (sellingPlan) url.searchParams.set('selling_plan', sellingPlan);
      else url.searchParams.delete('selling_plan');
      window.history.replaceState({}, '', url);

      this.highlightMedia(variant.featured_media_id);
      this.refreshVariantRegions(variant.id, sellingPlan);
    }

    highlightMedia(mediaId) {
      if (!mediaId || !this.dataset.galleryId) return;

      const target = document.getElementById(this.dataset.galleryId)?.querySelector(`[data-media-id="${mediaId}"]`);
      if (!target) return;

      const slider = target.closest('.slider');
      if (!slider) return;

      if (getComputedStyle(slider).overflowX === 'auto') {
        slider.scrollBy({
          left: target.getBoundingClientRect().left - slider.getBoundingClientRect().left,
          behavior: 'smooth',
        });
      } else {
        // Desktop grid layouts (grid_1/grid_2) don't scroll: bring the variant's
        // media to the front instead so it's the first thing shown.
        slider.prepend(target);
      }
    }

    async refreshVariantRegions(variantId, sellingPlan) {
      this.requestController?.abort();
      this.requestController = new AbortController();
      this.setAttribute('data-loading', '');

      try {
        const params = new URLSearchParams({ variant: variantId, sections: this.dataset.sectionId });
        if (sellingPlan) params.set('selling_plan', sellingPlan);

        const response = await fetch(`${window.location.pathname}?${params}`, {
          signal: this.requestController.signal,
        });
        if (!response.ok) return;

        const sections = await response.json();
        const doc = new DOMParser().parseFromString(sections[this.dataset.sectionId], 'text/html');

        this.querySelectorAll('[data-variant-region]').forEach((region) => {
          const updated = doc.querySelector(`[data-variant-region="${region.dataset.variantRegion}"]`);
          if (!updated) return;

          const quantity = region.querySelector('input[name="quantity"]')?.value;
          const updatedQuantityInput = quantity && updated.querySelector('input[name="quantity"]');
          if (updatedQuantityInput) updatedQuantityInput.value = quantity;

          // The selling-plan picker is itself a variant region (its choices depend
          // on the variant), so picking a plan replaces the very radio just
          // clicked. Its checked state already matches the pick (driven by the
          // selling_plan URL param above), only the focus ring needs restoring.
          const hadFocus = region.contains(document.activeElement);

          region.replaceWith(updated);

          if (updatedQuantityInput) updatedQuantityInput.dispatchEvent(new Event('change', { bubbles: true }));
          if (hadFocus) updated.querySelector('[data-selling-plan]:checked')?.focus();
        });
      } catch (error) {
        if (error.name !== 'AbortError') throw error;
      } finally {
        this.removeAttribute('data-loading');
      }
    }
  }

  customElements.define('product-form', ProductForm);

  /**
   * Add-to-cart bar fixed to the bottom of the product page (see
   * sections/product-sticky-add-to-cart.liquid): shown once the main
   * <product-form>'s buy buttons are above the viewport, and re-rendered
   * through the Section Rendering API when the variant picked there changes.
   */
  class StickyAddToCart extends AddToCart {
    connectedCallback() {
      super.connectedCallback();

      this.controller = new AbortController();
      const { signal } = this.controller;

      this.onScroll = () => {
        cancelAnimationFrame(this.frame);
        this.frame = requestAnimationFrame(() => this.updateVisibility());
      };

      window.addEventListener('scroll', this.onScroll, { passive: true, signal });
      window.addEventListener('resize', this.onScroll, { passive: true, signal });
      document.addEventListener('change', this.onProductFormChange.bind(this), { signal });

      // Theme editor: the bar stays shown while its section is selected.
      if (window.Shopify?.designMode) {
        const isOwn = (event) => event.target === this.closest('.shopify-section');
        const onEditorSelect = (selected) => (event) => {
          if (!isOwn(event)) return;
          this.editorSelected = selected;
          this.updateVisibility();
        };

        document.addEventListener('shopify:section:select', onEditorSelect(true), { signal });
        document.addEventListener('shopify:section:deselect', onEditorSelect(false), { signal });
      }

      this.updateVisibility();
    }

    disconnectedCallback() {
      this.controller.abort();
      this.requestController?.abort();
      cancelAnimationFrame(this.frame);
    }

    get productForm() {
      return document.querySelector('product-form');
    }

    // Never shown while the main form's options match no variant.
    updateVisibility() {
      const productForm = this.productForm;
      const anchor = productForm?.querySelector('.buy-buttons');
      const passed = Boolean(anchor) && anchor.getBoundingClientRect().bottom < 0;
      const visible = this.editorSelected || (passed && !productForm.hasAttribute('data-unavailable-combination'));

      this.toggleAttribute('data-visible', visible);
      this.inert = !visible;
    }

    // ProductForm.applyVariant has already written the picked variant and
    // selling plan to the URL by the time the change bubbles up here.
    onProductFormChange(event) {
      if (!this.productForm?.contains(event.target)) return;

      const params = new URL(window.location.href).searchParams;
      const sellingPlan = params.get('selling_plan');
      const sellingPlanInput = this.querySelector('input[name="selling_plan"]');

      if (sellingPlanInput) {
        sellingPlanInput.value = sellingPlan ?? '';
        sellingPlanInput.disabled = !sellingPlan;
      }

      const variantId = params.get('variant');
      if (variantId && variantId !== this.dataset.variantId) this.refresh(variantId);

      this.updateVisibility();
    }

    async refresh(variantId) {
      this.requestController?.abort();
      this.requestController = new AbortController();
      this.dataset.variantId = variantId;

      try {
        const params = new URLSearchParams({ variant: variantId, sections: this.dataset.sectionId });
        const response = await fetch(`${window.location.pathname}?${params}`, {
          signal: this.requestController.signal,
        });
        if (!response.ok) return;

        const sections = await response.json();
        const doc = new DOMParser().parseFromString(sections[this.dataset.sectionId], 'text/html');
        const region = this.querySelector('[data-sticky-add-to-cart-region]');
        const updated = doc.querySelector('[data-sticky-add-to-cart-region]');
        if (!region || !updated) return;

        // Keep what was chosen client-side (selling plan synced above, quantity typed in the bar).
        ['selling_plan', 'quantity'].forEach((name) => {
          const input = region.querySelector(`input[name="${name}"]`);
          const updatedInput = updated.querySelector(`input[name="${name}"]`);
          if (!input || !updatedInput) return;

          updatedInput.disabled = input.disabled;
          updatedInput.value = name === 'quantity' ? Math.min(Number(input.value), Number(updatedInput.max) || Infinity) : input.value;
        });

        region.replaceWith(updated);
      } catch (error) {
        if (error.name !== 'AbortError') throw error;
      }
    }
  }

  customElements.define('sticky-add-to-cart', StickyAddToCart);

  /**
   * Packaging choice of the quick view drawer (see snippets/quick-add.liquid):
   * one `id` radio per variant; the quantity selector and the add-to-cart
   * button live in the drawer's footer and follow the chosen variant.
   */
  class QuickViewForm extends AddToCart {
    connectedCallback() {
      super.connectedCallback();

      this.onChange = this.update.bind(this);
      this.root.addEventListener('change', this.onChange);
      this.update();
    }

    disconnectedCallback() {
      this.root.removeEventListener('change', this.onChange);
    }

    get root() {
      return this.closest('x-drawer') || this;
    }

    get button() {
      return this.root.querySelector('[type="submit"]');
    }

    update() {
      const variant = this.querySelector('input[name="id"]:checked');
      if (this.button) this.button.disabled = !variant;
      if (!variant) return;

      const max = Number(variant.dataset.max);
      const quantitySelector = this.root.querySelector('quantity-selector');
      if (quantitySelector) quantitySelector.dataset.max = max;

      const quantityInput = this.root.querySelector('input[name="quantity"]');
      if (quantityInput) {
        quantityInput.max = max;
        quantityInput.value = Math.min(Number(quantityInput.value) || 1, max);
      }
    }
  }

  customElements.define('quick-view-form', QuickViewForm);

  // Rendered in the overlay section group: its section id is generated
  // (sections--…__cart-drawer), so it's read from data-section-id.
  class CartDrawer extends CartFormMixin(XDrawer) {
    render(sections) {
      const doc = new DOMParser().parseFromString(sections[this.dataset.sectionId], 'text/html');
      const updated = doc.getElementById(this.id);
      if (!updated) return;

      ['heading', 'content', 'footer', 'aside'].forEach((slot) => {
        const current = this.querySelector(`[slot="${slot}"]`);
        const next = updated.querySelector(`[slot="${slot}"]`);
        if (current && next) current.replaceWith(next);
      });
    }
  }

  customElements.define('cart-drawer', CartDrawer);

  class LocalizationDrawer extends XDrawer {
    connectedCallback() {
      super.connectedCallback();
      this.addEventListener('change', this.onChange.bind(this));
    }

    onChange(event) {
      if (event.target.name !== 'country_code') return;
      this.refreshLanguages();
    }

    async refreshLanguages() {
      const region = this.querySelector('[data-localization-region="language"]');
      const form = this.querySelector('form');
      if (!region || !form) return;

      this.requestController?.abort();
      this.requestController = new AbortController();
      region.setAttribute('data-loading', '');

      try {
        await fetch(form.action, {
          method: 'POST',
          body: new FormData(form),
          signal: this.requestController.signal,
        });

        const params = new URLSearchParams({ sections: this.dataset.sectionId });
        const response = await fetch(`${window.location.pathname}?${params}`, {
          signal: this.requestController.signal,
        });
        if (!response.ok) return;

        const sections = await response.json();
        const doc = new DOMParser().parseFromString(sections[this.dataset.sectionId], 'text/html');
        const updated = doc.querySelector('[data-localization-region="language"]');
        if (updated) region.replaceWith(updated);
      } catch (error) {
        if (error.name !== 'AbortError') throw error;
      } finally {
        region.removeAttribute('data-loading');
      }
    }
  }

  customElements.define('localization-drawer', LocalizationDrawer);

  class SearchField extends HTMLElement {
    connectedCallback() {
      this.input = this.querySelector('.search-field__input');
      this.clearButton = this.querySelector('.search-field__clear');
      this.input.addEventListener('input', this.updateClearButton.bind(this));
      this.clearButton.addEventListener('click', this.clear.bind(this));
      this.updateClearButton();
    }

    updateClearButton() {
      this.clearButton.hidden = this.input.value.trim().length === 0;
    }

    clear() {
      this.input.value = '';
      this.input.focus();
      this.input.dispatchEvent(new Event('input', { bubbles: true }));
    }
  }

  customElements.define('search-field', SearchField);

  class PredictiveSearch extends XDrawer {
    connectedCallback() {
      super.connectedCallback();

      this.input = this.querySelector('.search-field__input');
      this.resultsContainer = this.querySelector('[data-predictive-search-results]');
      this.input.addEventListener('input', this.onInput.bind(this));
    }

    show() {
      super.show();
      this.input.focus();
    }

    close() {
      super.close();
      this.requestController?.abort();
    }

    onInput(event) {
      clearTimeout(this.debounce);

      const term = event.target.value.trim();

      if (term.length < 2) {
        this.requestController?.abort();
        this.resultsContainer.innerHTML = '';
        return;
      }

      this.debounce = setTimeout(() => this.getResults(term), 300);
    }

    async getResults(term) {
      this.requestController?.abort();
      this.requestController = new AbortController();
      this.setAttribute('data-loading', '');

      const params = new URLSearchParams({
        q: term,
        section_id: 'predictive-search',
        'resources[type]': 'product,collection,page,article',
        'resources[limit]': 4,
        'resources[limit_scope]': 'each',
      });

      try {
        const response = await fetch(`${window.routes.predictive_search}?${params}`, {
          signal: this.requestController.signal,
        });

        this.removeAttribute('data-loading');
        if (!response.ok) return;

        const doc = new DOMParser().parseFromString(await response.text(), 'text/html');
        const updated = doc.querySelector('[data-predictive-search-results]');
        if (!updated) return;

        this.resultsContainer.replaceWith(updated);
        this.resultsContainer = updated;
      } catch (error) {
        this.removeAttribute('data-loading');
        if (error.name !== 'AbortError') throw error;
      }
    }
  }

  customElements.define('predictive-search', PredictiveSearch);

  class CartPage extends CartFormMixin(HTMLElement) {
    render(sections) {
      const doc = new DOMParser().parseFromString(sections[this.dataset.sectionId], 'text/html');
      const updated = doc.getElementById(this.id);
      if (updated) this.innerHTML = updated.innerHTML;
    }
  }

  customElements.define('cart-page', CartPage);
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["header-assistant-trigger"] && !Shopify.designMode) return;
  try {
    document.addEventListener('click', (event) => {
    const trigger = event.target.closest('[data-assistant-trigger]');
    if (!trigger) return;
    document.dispatchEvent(
      new CustomEvent('lavinia:assistant:open', { detail: { prompt: trigger.dataset.assistantPrompt || '' } })
    );
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["header-drawer"] && !Shopify.designMode) return;
  try {
    class HeaderMenu extends HTMLElement {
    connectedCallback() {
      this.drawer = this.closest('x-drawer');
      this.panels = this.drawer.querySelector('.header-drawer__panels');

      // Panels sit in another slot of the drawer: listens on the drawer itself.
      this.onClick = this.onClick.bind(this);
      this.drawer.addEventListener('click', this.onClick);

      this.onTriggerClick = this.onTriggerClick.bind(this);
      document.addEventListener('click', this.onTriggerClick);
    }

    disconnectedCallback() {
      this.drawer.removeEventListener('click', this.onClick);
      document.removeEventListener('click', this.onTriggerClick);
    }

    get openPanels() {
      return Array.from(this.panels?.querySelectorAll('.header-drawer__panel.is-open') ?? []);
    }

    // The opener of a panel: an entry of the first level or of another panel.
    opener(panel) {
      return this.drawer.querySelector(`.header-drawer__link[aria-controls="${panel.id}"]`);
    }

    // Any trigger of the drawer (burger, "Menu", featured entries) starts
    // from the first level, featured entries then jump to their own panel.
    onTriggerClick(event) {
      const trigger = event.target.closest(`[aria-controls="${this.drawer.id}"]`);
      if (!trigger) return;

      this.reset();
      if (trigger.dataset.menuPanel) this.openPath(trigger.dataset.menuPanel);
    }

    onClick(event) {
      const opener = event.target.closest('.header-drawer__link[aria-controls]');
      if (opener) return this.open(document.getElementById(opener.getAttribute('aria-controls')), opener);

      if (event.target.closest('[data-menu-back]')) return this.back(event.target.closest('.header-drawer__panel'));
      if (event.target.closest('[data-menu-close]')) this.drawer.close();
    }

    open(panel, opener, animate = true) {
      if (!panel) return;

      panel.classList.toggle('no-transition', !animate);
      panel.scrollTop = 0;
      panel.inert = false;
      panel.classList.add('is-open');
      opener?.setAttribute('aria-expanded', 'true');
      if (animate) panel.querySelector('[data-menu-back]')?.focus({ preventScroll: true });
    }

    back(panel) {
      panel.classList.remove('no-transition');
      panel.classList.remove('is-open');
      panel.inert = true;

      const opener = this.opener(panel);
      opener?.setAttribute('aria-expanded', 'false');
      opener?.focus({ preventScroll: true });
    }

    // Opens a panel along with every parent panel, without sliding, so the
    // back button walks up the tree as if the user had drilled down.
    openPath(id) {
      const path = [];
      for (let panel = document.getElementById(id); panel; panel = document.getElementById(panel.dataset.parent)) {
        path.unshift(panel);
        if (!panel.dataset.parent) break;
      }

      path.forEach((panel) => {
        this.open(panel, this.opener(panel), false);
      });

      requestAnimationFrame(() => path.at(-1)?.querySelector('[data-menu-back]')?.focus({ preventScroll: true }));
    }

    reset() {
      this.openPanels.forEach((panel) => {
        panel.classList.add('no-transition');
        panel.classList.remove('is-open');
        panel.inert = true;
      });

      this.drawer.querySelectorAll('.header-drawer__link[aria-expanded="true"]').forEach((opener) => {
        opener.setAttribute('aria-expanded', 'false');
      });
    }
  }

  customElements.define('header-menu', HeaderMenu);
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["lightbox-scripts"] && !Shopify.designMode) return;
  try {
    class XLightbox extends HTMLElement {
    connectedCallback() {
      this.dialog = this.querySelector('dialog');

      this.querySelector('[data-lightbox-close]')?.addEventListener('click', () => this.close());
      this.dialog.addEventListener('close', () => this.onDialogClose());
      this.dialog.addEventListener('click', (event) => {
        if (event.target === this.dialog) this.close();
      });
    }

    open() {
      this.dialog.showModal();
      document.documentElement.classList.add('scroll-lock');
    }

    close() {
      this.dialog.close();
    }

    onDialogClose() {
      document.documentElement.classList.remove('scroll-lock');
    }
  }

  class ProductMediaFullscreen extends XLightbox {
    connectedCallback() {
      super.connectedCallback();

      this.main = this.querySelector('.product-media-fullscreen__main');

      this.main.addEventListener('pointerdown', this.onPointerDown.bind(this));
      this.main.addEventListener('pointermove', this.onPointerMove.bind(this));
      this.main.addEventListener('pointerup', this.onPointerUp.bind(this));
      this.main.addEventListener('pointercancel', this.onPointerUp.bind(this));
    }

    open(mediaId) {
      super.open();

      const target = mediaId && this.main.querySelector(`[data-media-id="${mediaId}"]`);
      target?.scrollIntoView({ behavior: 'instant', inline: 'start', block: 'nearest' });
      // scrollIntoView above is a no-op when the target is already in place (e.g. the
      // first slide), so force a sync of the thumbnail highlight in that case too.
      this.main.onScroll();
    }

    onDialogClose() {
      super.onDialogClose();
      this.resetZoom();
    }

    onPointerDown(event) {
      const item = event.target.closest('[data-zoomable]');
      if (!item) return;

      this.pointerId = event.pointerId;
      this.pointerStart = { x: event.clientX, y: event.clientY };
      this.dragged = false;
      if (item === this.zoomedItem) this.panStart = { x: this.panX, y: this.panY };
    }

    onPointerMove(event) {
      if (event.pointerId !== this.pointerId || !this.pointerStart) return;

      const dx = event.clientX - this.pointerStart.x;
      const dy = event.clientY - this.pointerStart.y;
      if (!this.dragged && Math.hypot(dx, dy) > 6) this.dragged = true;
      if (!this.dragged || !this.zoomedItem || !this.panStart) return;

      this.panX = this.panStart.x + dx;
      this.panY = this.panStart.y + dy;
      this.applyPan();
    }

    onPointerUp(event) {
      if (event.pointerId !== this.pointerId) return;

      const item = event.target.closest('[data-zoomable]');
      if (item && !this.dragged) this.toggleZoom(item, event);

      this.pointerId = undefined;
      this.pointerStart = undefined;
      this.panStart = undefined;
    }

    toggleZoom(item, event) {
      const wasZoomed = item === this.zoomedItem;
      this.resetZoom();
      if (wasZoomed) return;

      const image = item.querySelector('img, video');
      if (!image) return;

      const rect = image.getBoundingClientRect();
      image.style.transformOrigin = `${((event.clientX - rect.left) / rect.width) * 100}% ${((event.clientY - rect.top) / rect.height) * 100}%`;

      this.zoomedItem = item;
      this.zoomedImage = image;
      this.panX = 0;
      this.panY = 0;
      item.classList.add('is-zoomed');
      this.main.classList.add('is-zoom-active');
    }

    applyPan() {
      if (!this.zoomedImage) return;

      const rect = this.zoomedImage.getBoundingClientRect();
      this.panX = Math.min(Math.max(this.panX, -rect.width / 2), rect.width / 2);
      this.panY = Math.min(Math.max(this.panY, -rect.height / 2), rect.height / 2);
      this.zoomedImage.style.translate = `${this.panX}px ${this.panY}px`;
    }

    resetZoom() {
      if (!this.zoomedItem) return;

      this.zoomedItem.classList.remove('is-zoomed');
      this.zoomedImage.style.removeProperty('translate');
      this.zoomedImage.style.removeProperty('transform-origin');
      this.main.classList.remove('is-zoom-active');
      this.zoomedItem = undefined;
      this.zoomedImage = undefined;
    }
  }

  customElements.define('product-media-fullscreen', ProductMediaFullscreen);

  // The fullscreen trigger (see product-media.liquid) isn't an <x-drawer>, so it
  // isn't opened by the generic [aria-controls] delegate in global-web-components.liquid.
  document.addEventListener('click', (event) => {
    const trigger = event.target.closest('[data-fullscreen-trigger]');
    if (!trigger) return;

    const viewer = document.getElementById(trigger.getAttribute('aria-controls'));
    if (!(viewer instanceof ProductMediaFullscreen)) return;

    const gallery = trigger.closest('.product-media')?.querySelector(':scope > gallery-thumbnails');
    viewer.open(gallery?.activeMediaId);
  });

  class StoryViewer extends XLightbox {
    connectedCallback() {
      super.connectedCallback();

      this.track = this.querySelector('[data-stories-track]');
      this.slidesContainer = this.querySelector('[data-stories-slides]');
      this.progressContainer = this.querySelector('[data-stories-progress]');
      this.imageDuration = (Number(this.dataset.imageDuration) || 5) * 1000;

      this.track.querySelectorAll('[data-stories-slide]').forEach((slide) => this.slidesContainer.append(slide));
      this.slides = [...this.slidesContainer.children];

      this.slides.forEach(() => {
        const segment = document.createElement('div');
        segment.className = 'stories__progress-segment';
        segment.innerHTML = '<div class="stories__progress-fill"></div>';
        this.progressContainer.append(segment);
      });
      this.progressFills = [...this.progressContainer.querySelectorAll('.stories__progress-fill')];

      this.onVideoProgress = this.onVideoProgress.bind(this);
      this.onVideoEnded = () => this.next();
      this.tickImage = this.tickImage.bind(this);

      this.track.addEventListener('click', this.onBubbleClick.bind(this));
      this.dialog.addEventListener('keydown', (event) => {
        if (event.key === 'ArrowRight') this.next();
        if (event.key === 'ArrowLeft') this.prev();
      });

      this.addTapZone(this.querySelector('[data-stories-prev]'), -1);
      this.addTapZone(this.querySelector('[data-stories-next]'), 1);

      this.querySelector('[data-stories-arrow-prev]')?.addEventListener('click', () => this.prev());
      this.querySelector('[data-stories-arrow-next]')?.addEventListener('click', () => this.next());
    }

    onBubbleClick(event) {
      const bubble = event.target.closest('[data-stories-bubble]');
      if (!bubble) return;

      const index = this.slides.findIndex((slide) => slide.id === bubble.dataset.target);
      if (index !== -1) this.open(index);
    }

    addTapZone(button, direction) {
      if (!button) return;

      let pressed = false;

      const release = () => {
        if (!pressed) return;
        pressed = false;
        clearTimeout(this.holdTimer);

        if (this.paused) {
          this.setPaused(false);
        } else if (direction < 0) {
          this.prev();
        } else {
          this.next();
        }
      };

      button.addEventListener('pointerdown', () => {
        pressed = true;
        this.holdTimer = setTimeout(() => this.setPaused(true), 200);
      });
      button.addEventListener('pointerup', release);
      // Also releases if a touch slides off the button while held, so the hold doesn't get stuck.
      // Gated on `pressed` so a plain mouse hover (no pointerdown) can't trigger navigation on its own.
      button.addEventListener('pointerleave', release);
      // Keyboard activation (Enter/Space) fires a click with no pointer events before it.
      button.addEventListener('click', (event) => {
        if (event.detail !== 0) return;
        direction < 0 ? this.prev() : this.next();
      });
    }

    open(index) {
      super.open();
      this.goTo(index);
    }

    onDialogClose() {
      super.onDialogClose();
      this.cancelActiveMedia();
      this.setPaused(false);

      this.slides.forEach((slide) => {
        slide.hidden = true;
        const video = slide.querySelector('video');
        if (video) {
          video.pause();
          video.currentTime = 0;
        }
      });

      this.progressFills.forEach((fill) => {
        fill.style.inlineSize = '0%';
      });
    }

    next() {
      if (this.currentIndex >= this.slides.length - 1) {
        this.close();
      } else {
        this.goTo(this.currentIndex + 1);
      }
    }

    prev() {
      this.goTo(Math.max(this.currentIndex - 1, 0));
    }

    goTo(index) {
      this.cancelActiveMedia();
      this.currentIndex = index;

      this.slides.forEach((slide, i) => {
        slide.hidden = i !== index;
        this.progressFills[i].style.inlineSize = i < index ? '100%' : '0%';

        const video = slide.querySelector('video');
        if (video && i !== index) {
          video.pause();
          video.currentTime = 0;
        }
      });

      const video = this.slides[index].querySelector('video');

      if (video) {
        this.activeVideo = video;
        video.currentTime = 0;
        video.muted = true;
        video.addEventListener('timeupdate', this.onVideoProgress);
        video.addEventListener('ended', this.onVideoEnded);
        if (!this.paused) video.play().catch(() => {});
      } else {
        this.startImageTimer();
      }
    }

    onVideoProgress() {
      if (!this.activeVideo || !this.activeVideo.duration) return;

      const progress = this.activeVideo.currentTime / this.activeVideo.duration;
      this.progressFills[this.currentIndex].style.inlineSize = `${progress * 100}%`;
    }

    startImageTimer() {
      this.imageElapsed = 0;
      this.imageLastTimestamp = performance.now();
      this.imageRAF = requestAnimationFrame(this.tickImage);
    }

    tickImage(timestamp) {
      if (!this.paused) {
        this.imageElapsed += timestamp - this.imageLastTimestamp;
      }
      this.imageLastTimestamp = timestamp;

      const progress = Math.min(this.imageElapsed / this.imageDuration, 1);
      this.progressFills[this.currentIndex].style.inlineSize = `${progress * 100}%`;

      if (progress >= 1) {
        this.next();
        return;
      }

      this.imageRAF = requestAnimationFrame(this.tickImage);
    }

    setPaused(paused) {
      this.paused = paused;
      if (paused) {
        this.activeVideo?.pause();
      } else if (this.activeVideo) {
        this.activeVideo.play().catch(() => {});
      }
    }

    cancelActiveMedia() {
      cancelAnimationFrame(this.imageRAF);

      if (this.activeVideo) {
        this.activeVideo.removeEventListener('timeupdate', this.onVideoProgress);
        this.activeVideo.removeEventListener('ended', this.onVideoEnded);
        this.activeVideo = undefined;
      }
    }
  }

  customElements.define('story-viewer', StoryViewer);
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["load-more"] && !Shopify.designMode) return;
  try {
    class PaginatedResults extends HTMLElement {
    static restored = false;

    connectedCallback() {
      this.sectionId = this.dataset.sectionId;
      this.grid = this.querySelector('[data-paginated-grid]');
      if (!this.grid) return;

      // From the server, not the URL: after a filter change, the results are
      // swapped in before the URL is updated
      this.firstPage = Number(this.dataset.page) || 1;
      this.lastPage = this.firstPage;

      this.grid.firstElementChild?.setAttribute('data-page-start', this.firstPage);

      this.onClick = this.onClick.bind(this);
      this.onPopState = this.onPopState.bind(this);
      this.onPageHide = this.onPageHide.bind(this);
      this.addEventListener('click', this.onClick);
      window.addEventListener('popstate', this.onPopState);
      window.addEventListener('pagehide', this.onPageHide);

      window.history.replaceState({ ...window.history.state, paginatedPage: this.firstPage }, '');
      this.restore();
    }

    disconnectedCallback() {
      window.removeEventListener('popstate', this.onPopState);
      window.removeEventListener('pagehide', this.onPageHide);
    }

    // One entry per listing (path + filters + sort), whatever the page
    get storageKey() {
      const url = new URL(window.location.href);
      url.searchParams.delete('page');
      return `paginated-results:${url.pathname}${url.search}`;
    }

    onClick(event) {
      if (event.target.closest('[data-back-to-top]')) {
        window.scrollTo({ top: 0, behavior: 'smooth' });
        return;
      }

      const link = event.target.closest('a[data-load-more]');
      if (!link) return;

      event.preventDefault();
      if (link.hasAttribute('aria-busy')) return;
      this.load(link.dataset.loadMore, link);
    }

    // Fetches the page behind a "next"/"previous" link and inserts its items.
    // Falls back to following the link when anything goes wrong.
    async load(direction, link, { focus = true, keepScroll = true } = {}) {
      link.setAttribute('aria-busy', 'true');

      try {
        const url = new URL(link.href, window.location.origin);
        const page = Number(url.searchParams.get('page')) || 1;
        const requestUrl = new URL(url);
        requestUrl.searchParams.set('sections', this.sectionId);

        const response = await fetch(requestUrl);
        if (!response.ok) throw new Error(response.status);

        const sections = await response.json();
        const doc = new DOMParser().parseFromString(sections[this.sectionId], 'text/html');
        const grid = doc.querySelector('[data-paginated-grid]');
        if (!grid) throw new Error('No grid');

        const items = [...grid.children];
        items[0]?.setAttribute('data-page-start', page);

        if (direction === 'previous') {
          const scrollHeight = document.documentElement.scrollHeight;
          this.grid.prepend(...items);
          if (keepScroll) window.scrollBy(0, document.documentElement.scrollHeight - scrollHeight);

          this.firstPage = page;
          this.replaceRegion(doc, '[data-load-more-previous-region]');
          this.updateCount(doc, 'start');
        } else {
          this.grid.append(...items);

          this.lastPage = page;
          this.replaceRegion(doc, '[data-load-more-region]', '[data-load-more="next"]');
          this.updateCount(doc, 'end');

          window.history.pushState({ paginatedPage: page }, '', url.pathname + url.search);
          if (focus) {
            const target = items.find((item) => item.matches('.product-card')) || items[0];
            target?.querySelector('a[href]')?.focus({ preventScroll: true });
          }
        }
      } catch {
        window.location.href = link.href;
      } finally {
        link.removeAttribute('aria-busy');
      }
    }

    // Swaps one of our link regions for the fetched one (or removes the link
    // when the fetched page has none, e.g. the last page has no "next").
    replaceRegion(doc, regionSelector, linkSelector) {
      const region = this.querySelector(regionSelector);
      const updated = doc.querySelector(regionSelector);
      if (!region) return;

      if (!linkSelector) {
        if (updated) region.replaceWith(updated);
        else region.remove();
        return;
      }

      const link = region.querySelector(linkSelector);
      const updatedLink = updated?.querySelector(linkSelector);
      if (link && updatedLink) link.href = updatedLink.href;
      else link?.remove();
    }

    updateCount(doc, edge) {
      const count = this.querySelector('[data-results-count]');
      const updated = doc.querySelector('[data-results-count]');
      if (!count || !updated) return;

      count.dataset[edge] = updated.dataset[edge];
      count.textContent = count.dataset.template
        .replace('[start]', count.dataset.start)
        .replace('[end]', count.dataset.end);
    }

    // Back/forward between the pages loaded in this document: scroll to the page.
    onPopState(event) {
      const page = event.state?.paginatedPage;
      if (!page) return;

      const start = this.grid.querySelector(`[data-page-start="${page}"]`);
      if (start) start.scrollIntoView({ behavior: 'smooth', block: 'start' });
      else window.location.reload();
    }

    onPageHide() {
      try {
        sessionStorage.setItem(
          this.storageKey,
          JSON.stringify({ first: this.firstPage, last: this.lastPage, scrollY: window.scrollY })
        );
      } catch {}
    }

    // Back from a product page (without the back/forward cache): the URL is the
    // last page loaded, reload the ones before it and restore the scroll.
    async restore() {
      if (PaginatedResults.restored) return;
      PaginatedResults.restored = true;

      const navigation = performance.getEntriesByType('navigation')[0];
      if (navigation?.type !== 'back_forward') return;

      let saved;
      try {
        saved = JSON.parse(sessionStorage.getItem(this.storageKey));
      } catch {}
      if (!saved || saved.last !== this.lastPage) return;

      window.history.scrollRestoration = 'manual';

      while (this.firstPage > saved.first) {
        const link = this.querySelector('a[data-load-more="previous"]');
        if (!link) break;
        const firstPage = this.firstPage;
        await this.load('previous', link, { focus: false, keepScroll: false });
        if (this.firstPage === firstPage) break;
      }

      window.scrollTo(0, saved.scrollY);
    }
  }

  customElements.define('paginated-results', PaginatedResults);
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["pagination"] && !Shopify.designMode) return;
  try {
    class PaginationNav extends HTMLElement {
    connectedCallback() {
      this.addEventListener('click', this.onClick.bind(this));
    }

    onClick(event) {
      const link = event.target.closest('a[href]');
      if (!link) return;

      event.preventDefault();
      this.update(link.href);
    }

    async update(url) {
      const region = this.closest('[data-pagination-region]');
      if (!region) {
        window.location.href = url;
        return;
      }

      const regionId = region.dataset.paginationRegion;
      const requestUrl = new URL(url, window.location.origin);
      requestUrl.searchParams.set('sections', this.dataset.sectionId);

      region.setAttribute('data-loading', '');

      const response = await fetch(requestUrl);
      if (!response.ok) {
        window.location.href = url;
        return;
      }

      const sections = await response.json();
      const doc = new DOMParser().parseFromString(sections[this.dataset.sectionId], 'text/html');
      const updated = doc.querySelector(`[data-pagination-region="${regionId}"]`);
      if (!updated) {
        window.location.href = url;
        return;
      }

      region.replaceWith(updated);

      requestUrl.searchParams.delete('sections');
      window.history.replaceState({}, '', requestUrl.pathname + requestUrl.search);

      updated.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  }

  customElements.define('pagination-nav', PaginationNav);
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["product-scripts"] && !Shopify.designMode) return;
  try {
    class GalleryThumbnails extends HTMLElement {
    connectedCallback() {
      this.thumbnails = document.getElementById(this.dataset.thumbnailsFor);
      this.thumbnails?.addEventListener('click', this.onThumbnailClick.bind(this));
      this.addEventListener('scroll', this.onScroll.bind(this), { passive: true });
      this.onScroll();
    }

    // The media currently centered in view, used by the fullscreen trigger to
    // know which slide to open. Falls back to the first slide when nothing's
    // been scrolled yet (e.g. desktop grid layouts, which don't scroll).
    get activeMediaId() {
      return (this.activeItem ?? this.children[0])?.dataset.mediaId;
    }

    onThumbnailClick(event) {
      const button = event.target.closest('[data-target]');
      if (!button) return;

      document
        .getElementById(button.dataset.target)
        ?.scrollIntoView({ behavior: 'smooth', inline: 'start', block: 'nearest' });
    }

    onScroll() {
      const center = this.scrollLeft + this.clientWidth / 2;
      const active = [...this.children].find(
        (item) => center >= item.offsetLeft && center < item.offsetLeft + item.offsetWidth
      );

      // Keeps the slider's height matched to the slide currently in view (see
      // the --active-aspect-ratio consumer in product-media.liquid) instead
      // of the tallest slide in the whole gallery. Measured from the item's
      // rendered box (not its raw media aspect ratio) so it stays correct
      // when a slide is narrower than the track, e.g. the mobile "peek".
      if (active && active !== this.activeItem && active.offsetHeight) {
        this.style.setProperty('--active-aspect-ratio', this.clientWidth / active.offsetHeight);
      }

      this.activeItem = active;

      if (!this.thumbnails || !this.activeItem) return;

      this.thumbnails.querySelectorAll('[data-target]').forEach((button) => {
        const isActive = button.dataset.target === this.activeItem.id;
        button.classList.toggle('is-active', isActive);
        button.setAttribute('aria-current', String(isActive));
      });
    }
  }

  customElements.define('gallery-thumbnails', GalleryThumbnails);

  class QuantityBreaks extends HTMLElement {
    connectedCallback() {
      this.input = this.querySelector('input[name="quantity"]');
      this.addEventListener('click', this.onTierClick.bind(this));
      // Also runs after an AJAX variant swap reconnects this element, so a tier dropped for
      // lack of stock (see blocks/_quantity-breaks.liquid) falls back to the first one (qty 1).
      this.sync();
    }

    onTierClick(event) {
      const tier = event.target.closest('[data-quantity-break]');
      if (!tier) return;

      this.input.value = tier.dataset.quantityBreak;
      this.sync();
    }

    sync() {
      const tiers = [...this.querySelectorAll('[data-quantity-break]')];
      const active = tiers.find((tier) => tier.dataset.quantityBreak === this.input.value) ?? tiers[0];
      if (!active) return;

      this.input.value = active.dataset.quantityBreak;
      tiers.forEach((tier) => tier.classList.toggle('is-active', tier === active));
    }
  }

  customElements.define('quantity-breaks', QuantityBreaks);

  // Product info drawer: open the accordion matching the clicked trigger (the drawer itself
  // opens via the generic [aria-controls] delegate in global-web-components.liquid).
  document.addEventListener('click', (event) => {
    const trigger = event.target.closest('[data-accordion-target]');
    if (!trigger) return;

    const details = document.getElementById(trigger.dataset.accordionTarget);
    if (details) details.open = true;

    trigger.scrollIntoView({ behavior: 'smooth', inline: 'center', block: 'nearest' });
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["slider-controls"] && !Shopify.designMode) return;
  try {
    class ScrollSlider extends HTMLElement {
    connectedCallback() {
      this.track = document.getElementById(this.dataset.for);
      if (!this.track) return;

      this.prevButton = this.querySelector('[data-slider-prev]');
      this.nextButton = this.querySelector('[data-slider-next]');
      this.scrollbar = this.querySelector('.slider-controls__scrollbar');
      this.thumb = this.querySelector('.slider-controls__scrollbar-thumb');

      this.prevButton?.addEventListener('click', () => this.scrollByPage(-1));
      this.nextButton?.addEventListener('click', () => this.scrollByPage(1));
      this.track.addEventListener('scroll', () => this.update(), { passive: true });
      new ResizeObserver(() => this.update()).observe(this.track);

      this.update();
      this.setupAutoplay();
      this.setupDrag();
      this.setupThemeEditor();
    }

    disconnectedCallback() {
      this.pause();
    }

    // A page is the content box: a padded track (e.g. .slider--bleed) shows more than one page of slides.
    scrollByPage(direction) {
      const { paddingLeft, paddingRight } = getComputedStyle(this.track);
      const page = this.track.clientWidth - parseFloat(paddingLeft) - parseFloat(paddingRight);
      this.track.scrollBy({ left: direction * page * 0.9, behavior: 'smooth' });
    }

    update() {
      const maxScroll = this.track.scrollWidth - this.track.clientWidth;

      const hidden = maxScroll <= 1;

      // When the slider itself sits between the arrows (see the `content` param),
      // only hide the controls around it, never the whole element.
      if (this.contains(this.track)) {
        [this.prevButton, this.nextButton, this.scrollbar].forEach((control) => {
          if (control) control.hidden = hidden;
        });
      } else {
        this.hidden = hidden;
      }
      if (hidden) return;

      if (this.prevButton) this.prevButton.disabled = this.track.scrollLeft <= 0;
      if (this.nextButton) this.nextButton.disabled = this.track.scrollLeft >= maxScroll - 1;

      if (!this.scrollbar || !this.thumb) return;

      const thumbSize = Math.min(this.track.clientWidth / this.track.scrollWidth, 1);
      this.thumb.style.setProperty('--slider-thumb-size', `${thumbSize * 100}%`);

      const maxOffset = this.scrollbar.clientWidth - this.thumb.offsetWidth;
      const progress = maxScroll > 0 ? this.track.scrollLeft / maxScroll : 0;

      this.thumb.style.setProperty('--slider-thumb-offset', `${progress * maxOffset}px`);
    }

    setupAutoplay() {
      if (!('autoplay' in this.dataset)) return;

      this.reduceMotionQuery = window.matchMedia('(prefers-reduced-motion: reduce)');
      if (this.reduceMotionQuery.matches) return;

      [this.track, this].forEach((el) => {
        el.addEventListener('pointerenter', () => this.pause());
        el.addEventListener('pointerleave', () => this.play());
        el.addEventListener('focusin', () => this.pause());
        el.addEventListener('focusout', () => this.play());
      });

      this.autoplayEnabled = true;
      this.play();
    }

    play() {
      if (this.editorSelection) return;
      this.pause();
      const speed = (Number(this.dataset.autoplaySpeed) || 5) * 1000;
      this.timer = setInterval(() => this.advance(), speed);
    }

    pause() {
      clearInterval(this.timer);
    }

    advance() {
      const maxScroll = this.track.scrollWidth - this.track.clientWidth;

      if (this.track.scrollLeft >= maxScroll - 1) {
        this.track.scrollTo({ left: 0, behavior: 'smooth' });
      } else {
        this.scrollByPage(1);
      }
    }

    // In the theme editor, selecting a slide's block scrolls to it and holds
    // autoplay there until it's deselected, so the merchant sees what they edit.
    setupThemeEditor() {
      if (!window.Shopify?.designMode) return;

      this.track.addEventListener('shopify:block:select', (event) => {
        const slide = [...this.track.children].find((child) => child.contains(event.target));
        if (!slide) return;

        this.editorSelection = true;
        this.pause();

        const offset =
          slide.getBoundingClientRect().left -
          this.track.getBoundingClientRect().left -
          (parseFloat(getComputedStyle(this.track).scrollPaddingLeft) || 0);
        this.track.scrollBy({ left: offset, behavior: event.detail?.load ? 'instant' : 'smooth' });
      });

      this.track.addEventListener('shopify:block:deselect', () => {
        this.editorSelection = false;
        if (this.autoplayEnabled) this.play();
      });
    }

    // Mouse drag (touch and trackpad scroll natively). Native snapping is off
    // while dragging, then the track glides to the nearest slide, at least one
    // slide away in the drag direction (see glideTo).
    setupDrag() {
      const track = this.track;
      let drag = null;

      track.addEventListener('pointerdown', (event) => {
        if (event.pointerType !== 'mouse' || event.button !== 0) return;

        // Interactive media (3D viewer) handles its own drag, e.g. rotating the model.
        if (event.target.closest('model-viewer')) return;

        // Grabbing the track mid-glide stops it where it is.
        const interrupted = this.stopGlide();

        const vertical = getComputedStyle(track).overflowY === 'auto';
        drag = {
          vertical,
          interrupted,
          start: vertical ? event.clientY : event.clientX,
          scrollStart: this.scrollPosition(vertical),
        };
      });

      track.addEventListener('pointermove', (event) => {
        if (!drag) return;

        // Button released outside the track before the drag started
        if (!(event.buttons & 1)) {
          endDrag();
          return;
        }

        const delta =(drag.vertical ? event.clientY : event.clientX) - drag.start;

        // Only take over once the mouse actually moves, so a plain click still reaches its link.
        if (!drag.moved) {
          if (Math.abs(delta) <= 5) return;

          drag.moved = true;
          track.setPointerCapture(event.pointerId);
          track.classList.add('slider--dragging');
        }

        track[drag.vertical ? 'scrollTop' : 'scrollLeft'] = drag.scrollStart - delta;
      });

      const endDrag = () => {
        if (!drag) return;

        if (drag.moved) this.suppressClick = true;
        if (drag.moved || drag.interrupted) this.settle(drag);

        drag = null;
      };

      track.addEventListener('pointerup', endDrag);
      track.addEventListener('pointercancel', endDrag);
      track.addEventListener('lostpointercapture', endDrag);

      track.addEventListener(
        'click',
        (event) => {
          if (!this.suppressClick) return;
          this.suppressClick = false;
          event.preventDefault();
          event.stopPropagation();
        },
        { capture: true },
      );

      track.addEventListener('dragstart', (event) => event.preventDefault());
    }

    scrollPosition(vertical) {
      return vertical ? this.track.scrollTop : this.track.scrollLeft;
    }

    // Snap positions of the slides, as scroll offsets: slide edge on the scroll-padding, clamped to the scroll range.
    snapPositions(vertical) {
      const track = this.track;
      const style = getComputedStyle(track);
      const padding = parseFloat(vertical ? style.scrollPaddingTop : style.scrollPaddingLeft) || 0;
      const trackEdge = track.getBoundingClientRect()[vertical ? 'top' : 'left'];
      const max = vertical ? track.scrollHeight - track.clientHeight : track.scrollWidth - track.clientWidth;
      const current = this.scrollPosition(vertical);

      return [...track.children].map((child) => {
        const position = current + child.getBoundingClientRect()[vertical ? 'top' : 'left'] - trackEdge - padding;
        return Math.min(Math.max(position, 0), max);
      });
    }

    settle({ vertical, scrollStart }) {
      const track = this.track;
      const current = this.scrollPosition(vertical);
      const positions = this.snapPositions(vertical);
      const nearest = (list) => list.reduce((a, b) => (Math.abs(b - current) < Math.abs(a - current) ? b : a), list[0]);
      const ahead = positions.filter((p) => p > scrollStart + 1);
      const behind = positions.filter((p) => p < scrollStart - 1);

      let target = nearest(positions) ?? current;
      if (current > scrollStart && target <= scrollStart && ahead.length) target = nearest(ahead);
      if (current < scrollStart && target >= scrollStart && behind.length) target = nearest(behind);

      this.glideTo(vertical, target);
    }

    // Eased glide to a scroll offset, frame by frame: smoother than the native smooth scroll, and snapping
    // (off via .slider--dragging) only comes back once it truly ends, so the browser can't jump midway.
    glideTo(vertical, target) {
      const track = this.track;
      const property = vertical ? 'scrollTop' : 'scrollLeft';
      const from = track[property];
      const distance = target - from;
      const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      const duration = reduceMotion ? 0 : Math.min(Math.max(Math.abs(distance) * 1.2, 400), 800);
      let startTime;

      const step = (time) => {
        startTime ??= time;
        const progress = duration ? Math.min((time - startTime) / duration, 1) : 1;
        track[property] = from + distance * (1 - (1 - progress) ** 4);

        if (progress < 1) {
          this.glide = requestAnimationFrame(step);
        } else {
          this.glide = null;
          track.classList.remove('slider--dragging');
        }
      };

      this.stopGlide();
      this.glide = requestAnimationFrame(step);
    }

    stopGlide() {
      if (!this.glide) return false;
      cancelAnimationFrame(this.glide);
      this.glide = null;
      return true;
    }
  }

  customElements.define('scroll-slider', ScrollSlider);
  } catch(e) { console.error(e); }
})();

})();
